(function () {
  'use strict';

  const PREVIEW_POST_LIMIT = 3;
  const PREVIEW_INSIDER_LIMIT = 3;

  function featureForArticle(content, article) {
    const meta = article && article.querySelector('.fh-member-lab__post-meta');
    if (!meta) return 'unknown';
    const labels = Array.from(meta.querySelectorAll('span')).map(function (node) { return node.textContent.trim(); });
    if (labels.includes(content.dataset.boardFeatureDesigner || 'Bobbel Designer')) return 'bobbel-designer';
    if (labels.includes(content.dataset.boardFeatureLab || 'Member Lab')) return 'lab';
    return 'unknown';
  }

  function applyOracleView(content) {
    const oracle = content.querySelector('[data-member-lab-board]');
    const posts = oracle && oracle.querySelector('[data-member-lab-posts]');
    if (!oracle || !posts) return;

    const expanded = oracle.dataset.oracleExpanded === 'true';
    const filter = oracle.dataset.oracleFilter || 'all';
    let shown = 0;

    Array.from(posts.children).forEach(function (article) {
      if (!article.classList.contains('fh-member-lab__post')) return;
      const feature = featureForArticle(content, article);
      const matches = filter === 'all' || feature === filter;
      const withinPreview = expanded || shown < PREVIEW_POST_LIMIT;
      article.hidden = !(matches && withinPreview);
      if (matches && withinPreview) shown += 1;
    });

    oracle.querySelectorAll('[data-member-lab-oracle-filter]').forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.memberLabOracleFilter === filter);
      button.setAttribute('aria-pressed', button.dataset.memberLabOracleFilter === filter ? 'true' : 'false');
    });

    oracle.classList.toggle('fh-member-lab__oracle--expanded', expanded);
    const full = oracle.querySelector('[data-member-lab-oracle-full]');
    const open = oracle.querySelector('[data-member-lab-oracle-open]');
    if (full) full.hidden = !expanded;
    if (open) open.hidden = expanded;
  }

  function setOracleFilter(content, value, expand) {
    const oracle = content.querySelector('[data-member-lab-board]');
    if (!oracle) return;
    const filter = value === 'bobbel-designer' || value === 'lab' ? value : 'all';
    oracle.dataset.oracleFilter = filter;
    if (expand) oracle.dataset.oracleExpanded = 'true';
    const form = oracle.querySelector('[data-member-lab-compose]');
    if (form && filter !== 'all' && form.elements.feature) form.elements.feature.value = filter;
    applyOracleView(content);
  }

  function configureOracle(content) {
    const oracle = content.querySelector('[data-member-lab-board]');
    const posts = oracle && oracle.querySelector('[data-member-lab-posts]');
    if (!oracle || !posts || oracle.dataset.oracleUxReady === 'true') return;
    oracle.dataset.oracleUxReady = 'true';
    oracle.dataset.oracleFilter = 'all';
    oracle.dataset.oracleExpanded = 'false';

    oracle.addEventListener('click', function (event) {
      const filterButton = event.target.closest && event.target.closest('[data-member-lab-oracle-filter]');
      if (filterButton) {
        setOracleFilter(content, filterButton.dataset.memberLabOracleFilter, false);
        return;
      }
      const openButton = event.target.closest && event.target.closest('[data-member-lab-oracle-open]');
      if (openButton) {
        oracle.dataset.oracleExpanded = 'true';
        applyOracleView(content);
      }
    });

    const form = oracle.querySelector('[data-member-lab-compose]');
    if (form) form.addEventListener('reset', function () {
      window.setTimeout(function () {
        const active = oracle.dataset.oracleFilter || 'all';
        if (active !== 'all' && form.elements.feature) form.elements.feature.value = active;
      }, 0);
    });

    const params = new URLSearchParams(window.location.search);
    const requested = params.get('oracle');
    if (requested === 'bobbel-designer' || requested === 'lab') setOracleFilter(content, requested, true);

    new MutationObserver(function () { applyOracleView(content); }).observe(posts, { childList: true });
    applyOracleView(content);
  }

  function applyInsiderView(content) {
    const insider = content.querySelector('[data-member-lab-insider]');
    const list = insider && insider.querySelector('[data-member-lab-insider-posts]');
    if (!insider || !list) return;
    const expanded = insider.dataset.insiderExpanded === 'true';
    const cards = Array.from(list.querySelectorAll('.fh-member-lab__insider-card'));
    cards.forEach(function (card, index) { card.hidden = !expanded && index >= PREVIEW_INSIDER_LIMIT; });
    const expand = insider.querySelector('[data-member-lab-insider-expand]');
    const more = insider.querySelector('[data-member-lab-insider-more]');
    const hasMore = typeof content._memberLabInsiderNextCursor === 'string';
    if (expand) expand.hidden = expanded || (cards.length <= PREVIEW_INSIDER_LIMIT && !hasMore);
    if (more) more.hidden = !expanded || !hasMore;
  }

  function configureInsider(content) {
    const insider = content.querySelector('[data-member-lab-insider]');
    const list = insider && insider.querySelector('[data-member-lab-insider-posts]');
    if (!insider || !list || insider.dataset.insiderUxReady === 'true') return;
    insider.dataset.insiderUxReady = 'true';
    insider.dataset.insiderExpanded = 'false';

    const expand = insider.querySelector('[data-member-lab-insider-expand]');
    if (expand) expand.addEventListener('click', function () {
      insider.dataset.insiderExpanded = 'true';
      applyInsiderView(content);
    });

    const observer = new MutationObserver(function () { applyInsiderView(content); });
    observer.observe(list, { childList: true });
    applyInsiderView(content);
  }

  function initialize(content) {
    if (!content || content.dataset.memberLabUxReady === 'true') return;
    content.dataset.memberLabUxReady = 'true';
    configureOracle(content);
    configureInsider(content);
  }

  document.addEventListener('member-lab-content-ready', function (event) { initialize(event.detail); });
  document.querySelectorAll('[data-member-lab-content]').forEach(function (content) {
    const gate = content.closest('[data-member-lab-gate]');
    if (gate && gate.dataset.memberLabResolved === 'ENTITLED' && !content.hidden) initialize(content);
  });

  window.MemberLabUxRuntime = { initialize, setOracleFilter, applyOracleView, applyInsiderView };
})();
